module.exports = __webpack_public_path__ + "img/image-032.e3fa7698.png";